import React from "react";
import Layout from "../../components/Layout/Layout";

const BestExecution = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow">
                        <span className="dot"></span> Best Execution
                    </div>
                    <h1>Best Execution</h1>
                    <p>
                        We take all reasonable steps to achieve the best possible outcome for our clients when executing or
                        transmitting orders in relation to crypto-assets.
                    </p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container grid-2">
                    <article className="card">
                        <span className="kicker">How we execute orders</span>
                        <h2>Execution model</h2>
                        <p>
                            <strong>Outsourcing and Third-Party Services:</strong> In order to provide our services, we may rely on
                            third-party service providers for certain operational, technical, or infrastructure-related functions.
                            These may include:
                        </p>
                        <ul className="check-list micro-list">
                            <li>custody or wallet infrastructure providers</li>
                            <li>payment service providers</li>
                            <li>liquidity or execution partners</li>
                            <li>compliance and verification services</li>
                        </ul>
                        <p className="small-muted" style={{ marginTop: 12 }}>
                            We conduct due diligence on all third-party providers and maintain oversight of outsourced functions.
                        </p>
                        <p className="small-muted" style={{ marginTop: 12 }}>
                            Notwithstanding any outsourcing arrangements, we remain responsible for the proper performance of our
                            services in accordance with applicable regulatory requirements.
                        </p>
                        <p className="small-muted" style={{ marginTop: 12 }}>
                            Some services may be provided directly by third-party partners and may be subject to different regulatory
                            frameworks. Such services will be clearly identified where applicable.
                        </p>
                    </article>

                    <article className="card">
                        <span className="kicker">Factors considered</span>
                        <h2>What we take into account</h2>
                        <p>When executing orders, we consider a range of factors, including:</p>
                        <ul className="check-list micro-list">
                            <li>price</li>
                            <li>costs and fees</li>
                            <li>speed of execution</li>
                            <li>likelihood of execution and settlement</li>
                            <li>size and nature of the order</li>
                        </ul>
                        <p className="small-muted" style={{ marginTop: 12 }}>
                            The relative importance of these factors may vary depending on the specific circumstances of each
                            transaction.
                        </p>
                    </article>

                    <article className="card">
                        <span className="kicker">Third-party providers</span>
                        <h2>Use of external venues</h2>
                        <p>
                            Where third-party providers are used, we assess their performance on an ongoing basis to ensure that they
                            meet appropriate standards of reliability and efficiency.
                        </p>
                    </article>

                    <article className="card">
                        <span className="kicker">Transparency & policy</span>
                        <h2>Further information</h2>
                        <p>
                            Information on our execution approach is made available to clients prior to the use of our services.
                        </p>
                        <p style={{ marginTop: 12 }}>
                            For full details, please refer to our{" "}
                            <a href="https://static-assets.everest.org/web/files/best_execution_policy.pdf" target="_blank" style={{ color: "var(--brand)" }}>
                                Best Execution Policy
                            </a>
                            .
                        </p>
                    </article>
                </div>
            </section>
        </Layout>
    );
};

export default BestExecution;

